import { render, staticRenderFns } from "./GastAanTafel.vue?vue&type=template&id=19174ed2&"
import script from "./GastAanTafel.vue?vue&type=script&lang=js&"
export * from "./GastAanTafel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports